export default __webpack_public_path__ + "static/media/signal_ring.17be9e26.mp3";